/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{
  "rawString": ".suggestionsContainer_a8f5fd73{overflow-y:auto;overflow-x:hidden;max-height:300px}.suggestionsContainer_a8f5fd73 .ms-Suggestion-item:hover{background-color:"
}, {
  "theme": "neutralLighter",
  "defaultValue": "#f3f2f1"
}, {
  "rawString": ";cursor:pointer}.suggestionsContainer_a8f5fd73 .is-suggested{background-color:"
}, {
  "theme": "themeLighter",
  "defaultValue": "#deecf9"
}, {
  "rawString": "}.suggestionsContainer_a8f5fd73 .is-suggested:hover{background-color:"
}, {
  "theme": "themeLight",
  "defaultValue": "#c7e0f4"
}, {
  "rawString": ";cursor:pointer}"
}]);
export var suggestionsContainer = "suggestionsContainer_a8f5fd73";